













































































import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { specialChannel } from "@root/lib/mixins";
import extendCascader from "@/components/pages/ProductCreate/extendCascader.vue";
// import category from "@/views/Category.vue";
import channelAttrBrand from "@/components/pages/ProductCreate/channelComponents/channelAttrBrand.vue";
const productCreate = namespace("productCreate");
@Component({ components: { extendCascader, channelAttrBrand } })
export default class selectChannelInfo extends Mixins(specialChannel) {
  @productCreate.Action queryOnlineShopByChannel;
  @productCreate.Action queryConnCategoryList;
  @productCreate.Action queryDataDictionaryListLang;
  @Prop({ default: false }) visible;
  @Prop({ default: () => [] }) disabledShop;
  // visible = false;
  ruleForm: any = {
    channel: [],
    category: [],
    brandCode: ""
  };
  lableText: any = {
    channel: "",
    category: ""
  };
  categoryKey = new Date().getTime();
  shopKey = new Date().getTime();
  brandKey = new Date().getTime();
  get rules() {
    return {
      channel: [
        {
          required: true,
          message: this.$t("Basic.required_msg"),
          type: "array",
          trigger: "change"
        }
      ],
      category: [
        {
          required: true,
          message: this.$t("Basic.required_msg"),
          type: "array",
          trigger: "change"
        }
      ],
      brandCode: [
        {
          required: true,
          message: this.$t("Basic.required_msg"),
          trigger: "change"
        }
      ]
    };
  }
  get brandApiParam() {
    let result = {};
    if (this.ruleForm.channel && this.ruleForm.channel.length === 2) {
      result = {
        channelCode: this.ruleForm.channel[0],
        value: this.ruleForm.channel[1]
      };
    }
    return result;
  }
  @Watch("disabledShop", { deep: true })
  watchDisabledShop(val) {
    this.shopKey = new Date().getTime();
  }
  @Watch("visible")
  watchVisible(val) {
    if (val) {
      this.ruleForm = {
        channel: [],
        category: [],
        brandCode: ""
      };
      let $form: any = this.$refs.form;
      $form && $form.clearValidate();
      $form && $form.resetFields();
    }
  }
  @Watch("ruleForm.channel")
  watchChannel(val) {
    if (val && val.length == 2) {
      this.categoryKey = new Date().getTime();
      this.brandKey = new Date().getTime();
      this.ruleForm.category = [];
      this.ruleForm.brandCode = "";
    }
  }
  async shopLazyLoad(node, resolve) {
    const { level } = node;
    let result = [];

    if (node.level === 0) {
      let res = await this.queryDataDictionaryListLang({
        ddCode: "CONNECTOR_CHANNEL"
      });
      result = res;
    } else if (node.level === 1) {
      let res = await this.queryOnlineShopByChannel({
        input: {
          channelCode: node.data.value,
          authStatus: 1
        }
      });
      console.log(res, res.length, 87);

      if (res.length === 0) {
        console.log(node, 66);

        node.data.disabled = true;
      } else {
        res.forEach(_ => {
          _.isLeaf = true;
          let selectedList = this.disabledShop.filter(
            item => item.value === _.value
          );
          _.disabled = selectedList && selectedList.length > 0;
        });
        result = res;
      }
    }
    return resolve(result);
  }
  async categoryLazyLoad(node, resolve) {
    const { level } = node;
    let result = [];
    if (!this.ruleForm.channel || this.ruleForm.channel.length === 0) {
      return;
    }
    if (node.level === 0) {
      let res = await this.queryConnCategoryList({
        input: {
          channelCode: this.ruleForm.channel[0],
          shopCode: this.ruleForm.channel[1]
        }
      });
      result = res;
    } else {
      if (node.data.children && node.data.children.length) {
        result = node.data.children;
      } else {
        let res = await this.queryConnCategoryList({
          input: {
            channelCode: this.ruleForm.channel[0],
            shopCode: this.ruleForm.channel[1],
            categoryId: node.data.categoryId
          }
        });
        result = res;
      }
    }
    return resolve(result);
  }
  selectShop(data) {
    this.ruleForm.channel = [...data.value];
    this.lableText.channel = data.label;
  }
  selectCategory(data) {
    this.ruleForm.category = [...data.value];
    this.lableText.category = data.label;
  }

  submit() {
    let $form: any = this.$refs.form;
    $form.validate(val => {
      console.log(val, this.ruleForm);
      if (val) {
        this.$emit("addChannel", {
          value: this.ruleForm,
          label: this.lableText
        });
      } else {
        throw new Error("validate error");
      }
    });
  }
}
